"use client";

import { useRef } from "react";
import { SectionShell, useBandRowAlign, useWholeRowBlocks } from "@/components/sections/kit";
import { useEnterStagger } from "@/components/sections/kit/motion";
import { STATS } from "./data";

/** Trust stats — four figures the rest of the page already earned. */
export default function EnterpriseStatsSection() {
  const rootRef = useRef<HTMLDivElement>(null);

  useWholeRowBlocks(rootRef);
  useBandRowAlign(rootRef);
  useEnterStagger(rootRef, "[data-stat]", { y: 16, stagger: 0.08 });

  return (
    <SectionShell variant="tight" className="md:pt-px md:pb-px">
      <div ref={rootRef}>
        <div data-grid-block className="grid grid-cols-2 gap-y-8 text-center md:grid-cols-4">
          {STATS.map((stat, i) => (
            <div
              key={stat.v}
              data-stat
              className={`px-4 py-1.5 ${i > 0 ? "md:border-l md:border-line-2" : ""}`}
            >
              <div className="text-[34px] font-extrabold tracking-[-0.025em]">{stat.v}</div>
              <div className="mt-1 text-[12.5px] text-muted">{stat.l}</div>
            </div>
          ))}
        </div>
      </div>
    </SectionShell>
  );
}
